import { withTranslation } from 'react-i18next'
import { Button, Typography, Grid } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'

import FieldNotebooksForm from '../fieldNotebooksForm'

function ClimaticEvent({ 
  classes, 
  isFormSelected, 
  setArchiveSelected,
  archiveSelected,
  setIsFormSelected,
  t
}) {
  return(
    <Grid container className={classes.page__form}>
      {!isFormSelected && <Grid item sm={12} xs={12}>
        <Typography variant='caption'>
          {t('operation_to_register')}
        </Typography>
      </Grid>}
      {!isFormSelected && <Grid item sm={12} xs={12} className={classes.page__title}>
        <Button
          variant='outlined'
          color='primary'
          onClick={() => setArchiveSelected(undefined)}
        >
          <ArrowBackIcon color='primary' className='left_arrow' />
          {t('back')}
        </Button>
      </Grid>}
      <FieldNotebooksForm archive={archiveSelected} setIsFormSelected={setIsFormSelected} />
    </Grid>
  )
}

export default withTranslation()(ClimaticEvent)